import styled from "styled-components";

const Badge = ({ children, count }: { children: any; count?: number }) => {
  return (
    <BadgeContainer>
      {children}
      {count !== undefined && (
        <>
          {count > 0 ? <BadgeContent>{count}</BadgeContent> : <BadgeContent />}
        </>
      )}
    </BadgeContainer>
  );
};

export default Badge;

const BadgeContainer = styled.div`
  display: inline-block;
  position: relative;
`;

const BadgeContent = styled.span`
  position: absolute;
  top: -5px;
  right: -5px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 50%;
  background-color: #309e5b;
  color: white;
`;
